// Frame geometry for the dossier card, from the Untracked frame 188 recreation
// (KB 13-mu-hud-style-recipe-2026-09-14.md section 2.3). The lit side is the
// left edge and its two chamfers; the rest of the frame is unlit.

export interface CardFrame {
  outline: string;
  hairline: string;
  lit: string[];
  unlit: string[];
}

/** A rectangle with all four corners cut at 45 degrees. */
export function chamferRect(x: number, y: number, w: number, h: number, c: number): string {
  const r = x + w;
  const b = y + h;
  return `M${x + c} ${y} H${r - c} L${r} ${y + c} V${b - c} L${r - c} ${b} H${x + c} L${x} ${b - c} V${y + c} Z`;
}

/**
 * Paths for a card of the given size. Strokes sit inside the outline so the
 * card's box is its visible edge; the glow is allowed to spill outside it.
 */
export function cardFrame(w: number, h: number, chamfer = 30): CardFrame {
  const c = chamfer;
  const litInset = 8;
  const unlitInset = 4;
  const litTop = Math.round(w * 0.3);
  const litBottom = Math.round(w * 0.29);
  const leftBreak = Math.round(h * 0.66);
  const rightBreak = Math.round(h * 0.4);
  const gap = 11;
  const li = litInset;
  const ui = unlitInset;

  return {
    outline: chamferRect(0, 0, w, h, c),
    hairline: chamferRect(14, 14, w - 28, h - 28, Math.max(c - 8, 4)),
    lit: [
      `M${litTop} ${li} H${c + 2} L${li} ${c + 4} V${leftBreak}`,
      `M${li} ${leftBreak + gap} V${h - c - 2} L${c + 2} ${h - li} H${litBottom}`,
    ],
    unlit: [
      `M${litTop + gap} ${ui} H${w - c} L${w - ui} ${c} V${rightBreak}`,
      `M${w - ui} ${rightBreak + gap - 1} V${h - c} L${w - c} ${h - ui} H${litBottom + gap}`,
    ],
  };
}

/**
 * How long a one-shot type-on runs. The style guide tunes the glasses rate to
 * 30 characters a second, capped at one second per displayed line.
 */
export function typeOnDurationMs(text: string, charsPerLine = 34, cps = 30): number {
  const chars = text.length;
  if (chars === 0) return 0;
  const byRate = (chars / cps) * 1000;
  const lines = Math.ceil(chars / charsPerLine);
  return Math.round(Math.min(byRate, lines * 1000));
}
